import {
  DvGridComponent,
  DvQuickFilterComponent,
  DvGridToolbarComponent,
  DvActionComponent,
} from '@devinco/ui/grid';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import {
  DvDynamicFormModule,
  DvNavTabsModule,
  DvSavePanelModule,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '@shared/directives/directives.module';
import { AgGridModule } from 'ag-grid-angular';
import { ReportInformationTabComponent } from './components/report-tabs/report-information-tab/report-information-tab.component';
import { ReportFilterFormService } from './components/report-tabs/report-information-tab/services/report-filter-form.service';
import { ReportTabsComponent } from './components/report-tabs/report-tabs.component';
import { ReportsGridComponent } from './components/reports-grid/reports-grid.component';
import { ReportsPage } from './reports-page.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DvButtonComponent } from '@devinco/ui/dds';

import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';

export const ReportsRouteName = {
  Main: 'reports',
  Information: 'information',
};

const routes: Routes = [
  {
    path: '',
    component: ReportsPage,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${ReportsRouteName.Information}`,
      },
      {
        path: ':id',
        component: ReportTabsComponent,
        children: [
          {
            path: ReportsRouteName.Information,
            component: ReportInformationTabComponent,
            canDeactivate: [
              (component: ReportInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
        ],
      },
    ],
  },
];
@NgModule({
  declarations: [
    ReportsPage,
    ReportsGridComponent,
    ReportInformationTabComponent,
  ],
  imports: [
    CommonModule,
    ReportTabsComponent,
    RouterModule.forChild(routes),
    DirectivesModule,
    DvGridComponent,
    DvQuickFilterComponent,
    DvGridToolbarComponent,
    DvActionComponent,
    AgGridModule,
    DvNavTabsModule,
    DvDynamicFormModule,
    PipesModule,
    DvSavePanelModule,
    TranslateModule,
    DvButtonComponent,
    DvVerticalSplitterComponent,
  ],
  providers: [ReportFilterFormService],
})
export class ReportsPageModule {}
